import { EonUiIcon } from '@eon-ui/eon-ui-components-react';

const OnboardingPortalLinkArrow = (
    props: React.ComponentProps<typeof EonUiIcon> & { onClick?: () => void }
) => {
    const { onClick, style, ...rest } = props;
    return (
        <EonUiIcon
            name="arrow_right"
            onClick={onClick}
            style={{ cursor: "pointer", ...(style as any) }}
            {...rest}
        />
    );
};

export default OnboardingPortalLinkArrow;
